import { render, staticRenderFns } from "./Matomo.vue?vue&type=template&id=6325bc90&scoped=true&"
import script from "./Matomo.vue?vue&type=script&lang=js&"
export * from "./Matomo.vue?vue&type=script&lang=js&"
import style0 from "./Matomo.vue?vue&type=style&index=0&id=6325bc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325bc90",
  null
  
)

export default component.exports